import { cn } from "@/lib/utils";
import { PenIcon, PlusIcon } from "lucide-react";
import { LoadingSmall } from "../LoadingSmall";

export const ImageDimensionClass = "w-[150px] h-[150px]";

export const Placeholder = () => (
  <div className={cn(ImageDimensionClass, "bg-gray-200 flex items-center justify-center")}>
    <PlusIcon className="w-6 h-6" />
  </div>
);

export const FileLoading = () => (
  <div className={ImageDimensionClass}>
    <LoadingSmall />
  </div>
);

export const HoverPen = () => (
  <div className="absolute bg-muted p-4 rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-sm">
    <PenIcon className="w-4 h-4 text-dark" />
  </div>
);
